import React, { ReactNode, useState, useEffect } from "react";
import { handleError } from "../../utils/AppFunctions";
import SomethingWentWrong from "../../components/SomethingWentWrong";

interface IErrorBoundaryProps {
  children: ReactNode;
}

const ErrorBoundary: React.FC<IErrorBoundaryProps> = ({ children }) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    window.addEventListener("error", (event) => {
      handleError(event, "Global Error");
      setHasError(true);
    });
    return () => {
      window.removeEventListener("error", (event) =>
        handleError(event, "Global Error")
      );
    };
  }, []);

  if (hasError) {
    return <SomethingWentWrong />;
  }

  return <>{children}</>;
};

export default ErrorBoundary;
